import { render, staticRenderFns } from "./TerminaProduzione.vue?vue&type=template&id=2d86c666&scoped=true&"
import script from "./TerminaProduzione.vue?vue&type=script&lang=js&"
export * from "./TerminaProduzione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d86c666",
  null
  
)

export default component.exports